module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    staticClass: "pull-right"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-secondary",
      "title": "Terug",
      "exact": "",
      "to": {
        name: 'personList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })])], 1), _vm._v(" "), _c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('person.import')))])], 1)]), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isImporting
    }
  }), _vm._v(" "), (!_vm.isImporting) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.uploadFile()
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('person.uploadNextlotFile') + ':'
    }
  }, [_c('b-form-file', {
    ref: "fileinput",
    attrs: {
      "placeholder": _vm.$t('common.chooseFile')
    },
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.upload')) + "\n                    ")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-alert', {
    attrs: {
      "variant": "success",
      "show": _vm.successfullImported > 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('person.importSuccessPersons', {
    personCount: _vm.successfullImported,
    personCountNew: _vm.newImported
  })) + "\n                ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": !_vm.isNil(_vm.errors)
    }
  }, [_c('error-list', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usersWithErrors.length > 0),
      expression: "usersWithErrors.length > 0"
    }],
    attrs: {
      "hover": "",
      "items": _vm.usersWithErrors,
      "fields": _vm.tableFields,
      "caption-top": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(fixedBidNumber)",
      fn: function(row) {
        return [_vm._v(_vm._s(row.item.user.fixed_bid_number))]
      }
    }, {
      key: "cell(email)",
      fn: function(row) {
        return [_vm._v(_vm._s(row.item.user.email))]
      }
    }, {
      key: "cell(name)",
      fn: function(row) {
        return [_vm._v(_vm._s(row.item.user.first_name) + " " + _vm._s(row.item.user.last_name))]
      }
    }, {
      key: "cell(errors)",
      fn: function(row) {
        return [_c('error-list', {
          attrs: {
            "errors": row.item.errors
          }
        })]
      }
    }])
  }, [_c('template', {
    slot: "table-caption"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('person.importFailedPersons')) + ":\n                    ")])], 2)], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50f19524"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Person/PersonImport.vue
// module id = 1308
// module chunks = 1